import RestController from '../elements/RestController';

(function (window, document, $) {
    'use strict';

    $(function() {

        $('[data-action=expand-table]').on('click', async function () {

            var target = $($(this).data('target'));
            var rest = new RestController(vehicletree.resturl);

            var type = $(this).data('type');
            var postId = $(this).data('post');
            var generationId = $(this).data('generation');
            var offset = $(this).data('offset');

            $(this).attr('disabled', true);
            $(this).html('Bitte warten...');

            target.append(await rest.tableData(type, postId, generationId, offset));

            $(this).hide();
        });

    });
}(window, document, jQuery));